import { useEffect, useState } from "react"

// Returns whether `current` differs from `preChanges` (the last-saved snapshot),
// replacing the JSON.stringify comparison effect duplicated across controllers.
// Pass `normalize` to strip fields that should not count as changes (e.g. `stage`)
// before comparing. Recomputes when `current` changes, matching the original
// per-controller effects.
export const useDoneChanges = <T>(
  current: T,
  preChanges: T,
  normalize?: (value: T) => unknown
): boolean => {
  const [doneChanges, setDoneChanges] = useState<boolean>(false)

  useEffect(() => {
    const a = normalize ? normalize(current) : current
    const b = normalize ? normalize(preChanges) : preChanges
    setDoneChanges(JSON.stringify(a) !== JSON.stringify(b))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current])

  return doneChanges
}
